<template>
  <fts-modal
    :full-screen="fullView"
    append-container-class="quick-view-modal-container"
    :header-class="`quick-view__header loc-header ${
      fullView ? 'loc-header--tri' : ''
    }`"
    content-class="quick-view__content"
    footer-class="quick-view__footer"
    width="100%"
    :backdrop="isBackdrop"
    :footer="isFooter"
    class="fts-quick-view"
    @close="closeQuickView"
    v-if="show"
  >
    <!-- header -->
    <template #header>
      <!-- left -->
      <div class="loc-header__l">
        <!-- activity -->
        <template>
          <!-- activity -->
          <div class="loc-header-activity" v-if="selectedActivity">
            <i
              class="loc-header-activity__icon"
              :class="selectedActivity.icon"
              v-if="selectedActivity.icon"
            />
            <fts-moji
              :emoji="selectedActivity.emoji"
              :size="25"
              class="loc-header-activity__emoji"
              v-if="selectedActivity.emoji"
            />
            <div class="loc-header-activity__name">
              {{ selectedActivity.name }}
            </div>
          </div>
        </template>
        <!-- header entry info -->
        <div class="loc-header-info" v-if="header && header.id">
          <div class="loc-header-info__uppr">
            <div class="loc-header-info-title">{{ formTitle }}</div>
          </div>
          <div class="loc-header-info__lowr">
            <template v-if="multiple">
              <div class="loc-header-info-ids">{{ selectedItemsEtc }}</div>
              <div
                class="loc-header-info-ids__action"
                @click="showMultipleTable = !showMultipleTable"
              >
                {{ showMultipleTable ? "hide" : "show" }} details
              </div>
            </template>
            <template v-else>
              <!-- document -->
              <div class="loc-header-info-document__id">
                {{ header.documentId }}
              </div>
              <!-- created by -->
              <div class="fts-audit" v-if="header && header.audit">
                <fts-profile
                  class="audit-profile"
                  :userName="header.audit.createdBy"
                />
                <fts-tippy
                  class="audit-date-wrapper"
                  :content="
                    'created on ' +
                    moment(header.audit.createdDate).format('llll')
                  "
                >
                  <div slot="trigger" class="audit-date">
                    {{ moment(header.audit.createdDate).fromNow() }}
                  </div>
                </fts-tippy>
              </div>
            </template>
          </div>
        </div>
      </div>
      <!-- center -->
      <div class="loc-header__c">
        <template v-if="module && module.id && module.name">
          <fts-moji
            :emoji="module.emoji"
            :size="25"
            class="loc-header-title__emoji"
            v-if="module.emoji"
          />
          <div class="loc-header-title">{{ module.name }}</div>
        </template>
      </div>
      <!-- right -->
      <div class="loc-header__r">
        <!-- state -->
        <fts-state
          :state="header.state"
          class="loc-header-state"
          v-if="header && header.state && header.state.name && !multiple"
        />
        <template v-if="header && !isError">
          <!-- design -->
          <router-link
            :to="designRoute"
            v-slot="{ href }"
            v-if="isAdminUser && designRoute"
          >
            <fts-btn
              tag="a"
              text
              icon
              color="secondary"
              box-shadow-none
              :href="href"
            >
              <font-awesome-icon :icon="['fas', 'wand-magic-sparkles']" />
            </fts-btn>
          </router-link>
          <!-- share -->
          <fts-btn text icon @click="share" v-if="header.id && !multiple">
            <font-awesome-icon :icon="['fas', 'share-alt']" />
          </fts-btn>
          <!-- basket -->
          <fts-basket
            mode="put"
            @addToForm="addToForm"
            class="lv-nav-action"
            v-if="entry !== 'view'"
          />
          <!-- watch -->
          <fts-btn
            text
            icon
            :color="header.watch ? 'primary' : 'gray-light'"
            @click="toggleWatch"
            v-if="header.id && !multiple"
          >
            <font-awesome-icon :icon="['far', 'star']" />
          </fts-btn>
          <!-- history -->
          <div :class="{ 'history-count-wrapper': header.commentCount }" v-if="header.id && !multiple">
            <fts-btn
              text
              icon
              :color="header.commentCount ? 'primary' : 'gray-light'"
              @click="toggleHistory"
            >
              <font-awesome-icon :icon="['far', 'comment-alt']" />
            </fts-btn>
            <div class="history-count" v-if="header.commentCount">
              {{ header.commentCount }}
            </div>
          </div>
          <!-- actions -->
          <fts-dropdown-select
            append-to-body
            placement="bottom-end"
            prevent-overflow-alt-axis
            prevent-overflow-tether-off
            append-content-class="loc-activity-dropdown-menu"
            :options="sidebarActions"
            @selected="executeAction"
            v-if="!selectedActivity">
            <fts-btn slot="toggle" text icon>
              <font-awesome-icon :icon="['fas', 'ellipsis-v']" />
            </fts-btn>
            <div
              slot="option"
              slot-scope="{ option, select, defaultClass }"
              :class="`${defaultClass} loc-activity-option`"
              @click="select(option)">
              <!-- standard activity -->
              <template v-if="option.type === 'standard'">
                <i class="loc-activity-option__icon" :class="option.icon" />
                <div class="loc-activity-option__name">{{ option.name }}</div>
              </template>
              <!-- document -->
              <template v-else-if="option.type === 'template'">
                <font-awesome-icon :icon="['far', 'file-pdf']" class="loc-activity-option__icon fts-file-pdf" v-if="option.typeId === 'pdf'" />
                <font-awesome-icon :icon="['far', 'file-alt']" class="loc-activity-option__icon fts-file-excel" v-else-if="option.typeId === 'spreadsheet'" />
                <font-awesome-icon :icon="['far', 'file-code']" class="loc-activity-option__icon fts-file-html" v-else-if="option.typeId === 'html'" />
                <font-awesome-icon :icon="['far', 'file']" class="loc-activity-option__icon fts-file-default" v-else />
                <div class="loc-activity-option__name">{{ option.name }}</div>
              </template>
              <!-- activity/action -->
              <template v-else>
                <fts-moji
                  :emoji="option.emoji"
                  :size="14"
                  class="loc-activity-option__emoji"
                  v-if="option.emoji"
                />
                <div
                  class="loc-activity-option__name"
                  :style="{color: option.color}"
                >
                  {{ option.name }}
                </div>
              </template>
            </div>
          </fts-dropdown-select>
          <!-- expand/collapse -->
          <fts-tippy
            :option="{ placement: 'bottom' }"
            :content="`switch to ${fullView ? 'compact' : 'immersive'} view`"
            v-if="selectedActivity || fullViewRight"
          >
            <fts-btn
              slot="trigger"
              text
              icon
              @click="toggleView"
            >
              <font-awesome-icon
                :icon="['fas', 'compress-alt']"
                fixed-width
                v-if="fullView"
              />
              <font-awesome-icon
                :icon="['fas', 'expand-alt']"
                fixed-width
                v-else
              />
            </fts-btn>
          </fts-tippy>
        </template>
        <!-- close -->
        <fts-btn text icon @click="closeQuickView">
          <font-awesome-icon :icon="['fas', 'times']" />
        </fts-btn>
      </div>
    </template>
    <!-- body -->
    <template #body>
      <div class="lv-body fts-scrollbar">
        <div class="mock-element" ref="mockElement"></div>
        <!-- form switcher -->
        <div
          class="lv-form-switcher"
          v-if="selectedActivity && selectedActivity.id != 'create' && !multiple && !isError"
        >
          <fts-btn text text-transform-init @click="showDetails(true)" v-if="!showEntryDetails">
            show details
          </fts-btn>
          <fts-btn text text-transform-init @click="showDetails(false)" v-else>
            hide details
          </fts-btn>
        </div>
        <!-- Multiple Ids -->
        <fts-transition-expand>
          <div class="lv-entries" v-if="showMultipleTable">
            <table class="fts-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Title</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td>{{ item.documentId }}</td>
                  <td>{{ item.title }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </fts-transition-expand>
        <!-- View -->
        <fts-transition-expand>
          <!-- error -->
          <div class="error-wrapper" v-if="viewFormIsError && showEntryDetails">
            <div class="error-icon">
              <font-awesome-icon :icon="['fas', 'times']" fixed-width />
            </div>
            <div class="error-title">An Error Occurred</div>
            <div class="error-description">{{viewFormError}}</div>
          </div>
          <!-- classification -->
          <fts-classification
            class="content-body-classification"
            :locusId="formData.id"
            :vectorId="vectorId"
            :users="users"
            :comment="comment"
            :viewData="viewData"
            :view="true"
            :username="username"
            v-else-if="viewData && showEntryDetails"
          />
        </fts-transition-expand>
        <!-- form seperator -->  
        <transition name="fade-in">
          <div class="lv-form-separator" v-if="selectedActivity && selectedActivity.id && showEntryDetails">
            <div class="form-separator-title" v-if="selectedActivity.standard">
              <i class="form-seperator-icon" :class="selectedActivity.icon" v-if="selectedActivity.icon" />
              <div class="form-seperator-name">{{selectedActivity.name}}</div>
            </div>
            <div class="form-separator-title" v-else>
              <fts-moji
                :emoji="selectedActivity.emoji"
                :size="17"
                class="form-seperator-emoji"
                v-if="selectedActivity.emoji" />
              <div class="form-seperator-name">{{selectedActivity.name}}</div>
            </div>
          </div>
        </transition>
        <!-- Activity -->
        <fts-transition-expand>
          <!-- error -->
          <div class="error-wrapper" v-if="activityFormIsError">
            <div class="error-icon">
              <font-awesome-icon :icon="['fas', 'times']" fixed-width />
            </div>
            <div class="error-title">An Error Occurred</div>
            <div class="error-description">{{activityFormError}}</div>
          </div>
          <!-- classification -->
          <fts-classification
            ref="form"
            class="content-body-classification"
            :locus="{}"
            :locusId="locusIds[0]"
            :vectorId="vectorId"
            :users="users"
            :comment="comment"
            :comment-section="commentRight"
            :view="false"
            :activityId="selectedActivity.id"
            :activity="selectedActivity.name"
            @cancel="cancel"
            :submitting="submitting"
            @submit="submit"
            :key="selectedActivity.id"
            :username="username"
            v-else-if="
              selectedActivity &&
              selectedActivity.id != 'assign' &&
              selectedActivity.id != 'changeStatus' &&
              selectedActivity.id != 'duplicate' &&
              selectedActivity.id != 'delete'
            "
          />
          <!-- standard activity -->
          <div class="standard-activity-form" v-else-if="selectedActivity">
            <div
              class="standard-activity-form-content"
              :class="{ 'single-selected': !multiple }"
            >
              <!-- Delete -->
              <div
                class="standard-activity-form-title"
                v-if="selectedActivity.id === 'delete'"
              >
                Are you sure to delete?
              </div>
              <!-- Duplicate  -->
              <div
                class="standard-activity-form-title"
                v-else-if="selectedActivity.id === 'duplicate'"
              >
                Are you sure to duplicate?
              </div>
              <!-- State -->
              <div class="standard-activity-state" v-else-if="selectedActivity.id === 'changeStatus'">
                <div class="state-label-wrapper">
                  <div class="state-label">
                    Changing state to
                  </div>  
                  <div class="state-error" v-if="validationError()">{{validationError()}}</div>
                </div>
                <fts-dropdown-select
                  append-to-body
                  prevent-overflow-alt-axis
                  prevent-overflow-tether-off
                  v-model="selectedState"
                  :options="states"
                  class="state-dropdown"
                >
                  <fts-state
                    slot="toggle"
                    slot-scope="{ selectedOption }"
                    :state="
                      selectedOption && selectedOption.name
                        ? selectedOption
                        : { name: 'select state' }
                    "
                    :options="states"
                  />
                  <div
                    slot="option"
                    slot-scope="{ option, select, defaultClass }"
                    :class="defaultClass"
                    @click="select(option)"
                  >
                    <fts-state :state="option" />
                  </div>
                </fts-dropdown-select>    
              </div>
              <!-- Assign -->
              <fts-assign
                :assign-data="formData"
                v-else-if="selectedActivity.id === 'assign'"
              />
            </div>
            <!-- Standard Activity Comment -->
            <fts-comment
              class="standard-activity-comment"
              :vectorId="vectorId"
              :comment="comment"
              v-if="commentRight && selectedActivity.id != 'duplicate'"
            />
          </div>
        </fts-transition-expand>
        <!-- full view standard activity -->
        <div
          class="full-view-standard"
          v-if="
            fullView &&
            selectedActivity &&
            (
              selectedActivity.id == 'assign' ||
              selectedActivity.id == 'changeStatus' ||
              selectedActivity.id == 'delete' ||
              selectedActivity.id == 'duplicate'
            ) &&
            !isError
          "
        >
          <fts-btn
            text
            :disabled="submitting"
            @click="cancel"
          >
            <font-awesome-icon :icon="['fas', 'times']" /> Cancel
          </fts-btn>
          <fts-btn
            color="danger"
            :loading="submitting"
            @click="submit"
            v-if="selectedActivity.id === 'delete'"
          >
            <i :class="selectedActivity.icon" /> {{ selectedActivity.name }}
          </fts-btn>
          <fts-btn
            color="primary"
            :loading="submitting"
            @click="submit"
            v-else
          >
            <i :class="selectedActivity.icon" /> {{ selectedActivity.name }}
          </fts-btn>
        </div>
      </div>
      <!-- full view activities, actions -->
      <div class="quick-view-fab" v-if="fullView && selectedActivity == null && !isError">
        <div class="quick-view-fab-wrapper">
          <!-- single activity -->
          <fts-btn
            :color="executableActivity.color || 'primary'"
            outline
            text-transform-init
            :emoji="executableActivity.emoji"
            class="btn-activity quick-view-fab--single"
            @click="execute(executableActivity, 'activity')"
            v-if="executableActivity"
          >
            <span class="btn-activity-label">{{executableActivity.name}}</span>
          </fts-btn>
          <!-- Executable List -->
          <fts-dropdown-select
            append-to-body
            placement="top-end"
            prevent-overflow-alt-axis
            prevent-overflow-tether-off
            append-content-class="loc-activity-dropdown-menu"
            :options="sidebarActions"
            @selected="executeAction"
            v-else
          >
            <fts-btn slot="toggle" color="primary"> Activity </fts-btn>
            <div
              slot="option"
              slot-scope="{ option, select, defaultClass }"
              :class="`${defaultClass} loc-activity-option`"
              @click="select(option)"
            >
              <!-- standard activity -->
              <template v-if="option.type === 'standard'">
                <i class="loc-activity-option__icon" :class="option.icon" />
                <div class="loc-activity-option__name">{{ option.name }}</div>
              </template>
              <!-- document -->
              <template v-else-if="option.type === 'template'">
                <font-awesome-icon :icon="['far', 'file-pdf']" class="loc-activity-option__icon fts-file-pdf" v-if="option.typeId === 'pdf'" />
                <font-awesome-icon :icon="['far', 'file-alt']" class="loc-activity-option__icon fts-file-excel" v-else-if="option.typeId === 'spreadsheet'" />
                <font-awesome-icon :icon="['far', 'file-code']" class="loc-activity-option__icon fts-file-html" v-else-if="option.typeId === 'html'" />
                <font-awesome-icon :icon="['far', 'file']" class="loc-activity-option__icon fts-file-default" v-else />
                <div class="loc-activity-option__name">{{ option.name }}</div>
              </template>
              <!-- activity/action -->
              <template v-else>
                <fts-moji
                  :emoji="option.emoji"
                  :size="14"
                  class="loc-activity-option__emoji"
                  v-if="option.emoji"
                />
                <div
                  class="loc-activity-option__name"
                  :style="{color: option.color}"
                >
                  {{ option.name }}
                </div>
              </template>
            </div>
          </fts-dropdown-select>
        </div>
      </div>
      <!-- history -->
      <fts-history
        :locus-id="header.id"
        :vector-id="vectorId"
        :comment-section="commentRight"
        :init-open="Boolean(header.commentCount && header.commentCount > 0)"
        :init-comment="!selectedActivity"
        @added="historyAdded"
        v-if="header.id && !loading && !multiple && !isError"
        ref="ftsHistory"
      />
    </template>
    <!-- footer -->
    <template #footer>
      <!-- progress -->
      <div v-if="progress">
        <span>Progress: {{ progress }}</span>
      </div>
      <!-- footer (activity, custom, document) -->
      <div class="footer-action" v-if="!selectedActivity && footer">
        <div class="fts-list-view-action" >
          <!-- activity -->
          <fts-btn
            outline
            :color="activity.color || 'primary'"
            :emoji="activity.emoji"
            text-transform-init
            class="btn-activity"
            v-for="activity in footer.activities"
            :key="activity.id"
            @click="execute(activity, 'activity')">
            <span class="btn-activity-label">{{activity.name}}</span>
          </fts-btn>
          <!-- custom -->
          <fts-btn
            outline
            :color="action.color || 'ternary-blue'"
            :emoji="action.emoji"
            text-transform-init
            class="btn-activity"
            v-for="action in footer.customs"
            :key="action.id"
            @click="execute(action, 'custom')">
            <span :class="{'btn-activity-label': !action.color}">{{action.name}}</span>
          </fts-btn>
          <!-- documents -->
          <fts-btn
            outline
            color="ternary-green"
            text-transform-init
            class="btn-activity"
            v-for="action in footer.documents"
            :key="action.id"
            @click="execute(action, 'document')">
            <font-awesome-icon :icon="['far', 'file-pdf']" class="btn-activity-icon fts-file-pdf" v-if="action.typeId === 'pdf'" />
            <font-awesome-icon :icon="['far', 'file-alt']" class="btn-activity-icon fts-file-excel" v-else-if="action.typeId === 'spreadsheet'" />
            <font-awesome-icon :icon="['far', 'file-code']" class="btn-activity-icon fts-file-html" v-else-if="action.typeId === 'html'" />
            <font-awesome-icon :icon="['far', 'file']" class="btn-activity-icon fts-file-default" v-else />
            <span class="btn-activity-label">{{action.name}}</span>
          </fts-btn>
        </div>
      </div>
      <!-- quick view standard activity -->
      <div
        class="footer-standard"
        v-if="
          selectedActivity &&
          (selectedActivity.id == 'assign' ||
            selectedActivity.id == 'changeStatus' ||
            selectedActivity.id == 'delete' ||
            selectedActivity.id == 'duplicate')
        "
      >
        <fts-btn
          text
          :disabled="submitting"
          @click="cancel"
        >
          <font-awesome-icon :icon="['fas', 'times']" /> Cancel
        </fts-btn>
        <fts-btn
          color="danger"
          :loading="submitting"
          @click="submit"
          v-if="selectedActivity.id === 'delete'"
        >
          <i :class="selectedActivity.icon" /> {{ selectedActivity.name }}
        </fts-btn>
        <fts-btn
          color="primary"
          :loading="submitting"
          @click="submit"
          v-else
        >
          <i :class="selectedActivity.icon" /> {{ selectedActivity.name }}
        </fts-btn>
      </div>
    </template>
  </fts-modal>
</template>

<script>
import Vue from "vue";
import Vuelidate from "vuelidate";
import { required } from "vuelidate/lib/validators";
Vue.use(Vuelidate);

import moment from "moment";
import firebase from "firebase/app";
import "firebase/analytics";

import { authorizationStore } from '../../store/authorizationStore';
import { classificationStore } from "../../store/classificationStore";
import { clientStore } from "../../store/clientStore";
import commons from "../../commons/commons";

import FTSClassification from "../FTSClassification";
import FTSModal from "../FTSModal";
import FTSDropdownSelect from "../FTSDropdownSelect";
import FTSTippy from "../FTSTippy";
import FTSTransitionExpand from "../FTSTransitionExpand";
import FTSComment from "../FTSComment";
import FTSHistory from "../history/FTSHistory";
import FTSProfile from "../FTSProfile";
import FTSState from "../FTSState";
import FTSMoji from "../FTSMoji";
import FTSBasket from "../FTSBasket";
import FTSBtn from "../FTSBtn";
import FTSBtnHold from "../FTSBtnHold";
import FTSAssign from "../FTSAssign";

const moduleUnavailableMessage = "Module isn't available. The module you're trying to access is unpublished or have been removed.";
const entryUnavailableMessage = "Something went wrong with this entry.";
const activityUnavailableMessage = "Something went wrong with this activity.";

export default {
  components: {
    "fts-classification": FTSClassification,
    "fts-modal": FTSModal,
    "fts-dropdown-select": FTSDropdownSelect,
    "fts-tippy": FTSTippy,
    "fts-transition-expand": FTSTransitionExpand,
    "fts-comment": FTSComment,
    "fts-history": FTSHistory,
    "fts-profile": FTSProfile,
    "fts-state": FTSState,
    "fts-moji": FTSMoji,
    "fts-basket": FTSBasket,
    "fts-btn": FTSBtn,
    "fts-btn-hold": FTSBtnHold,
    "fts-assign": FTSAssign,
  },
  data() {
    return {
      header: {},
      footer: {},
      listingId: null,
      activity: {},
      viewData: null,
      showEntryDetails: false,
      // visibility
      show: false,
      selectedActivity: null,
      entry: null,
      loading: false,
      // Data
      vectorId: null,
      items: [],
      formData: {},
      showMultipleTable: false,
      submitting: false,
      selectedState: {},
      username: null,
      comment: {},
      progress: null,
      refreshList: false,
      fullView: false,
      // error handling
      viewFormIsError: false,
      viewFormError: null,
      activityFormIsError: false,
      activityFormError: null,
    };
  },
  validations() {
    let selectedState = {};

    if (this.selectedActivity && this.selectedActivity.id === 'changeStatus') {
      selectedState = {
        name: { required }
      }
    }

    return { selectedState };
  },
  methods: {
    async loadViewForm() {
      try {
        let vm = this;
        vm.showEntryDetails = true;
        vm.viewFormIsError = false;
        let viewResult = await classificationStore.dispatch("loadViewForm", {
          query: vm.$route.query,
          locusId: vm.locusIds[0],
          listingId: vm.listing,
          activityId: vm.fullView ? "view" : "quickView",
          users: vm.users,
        });

        vm.header = viewResult.header;
        vm.footer = viewResult.footer;
        vm.viewData = viewResult.viewData;
        /* custom visibility */
        if (vm.footer && vm.footer.customs && vm.footer.customs.length) {
          const header = {...vm.header};
          const items = [{
            id: header.id,
            audit: header.audit,
            documentId: header.documentId,
            state: header.state,
            title: header.title,
            extension: vm.viewData && vm.viewData.formData ? {...vm.viewData.formData} : {},
          }];
          vm.footer.customs = vm.footer.customs.filter(x => {
            if (Boolean(x.condition)) {
              try {
                return Boolean(eval(x.condition));
              } catch(err) {
                console.error('[Custom:Condition error]', err);
                return false;
              }
            }
            return true;
          });
        }

        if (viewResult.header && viewResult.header.moduleId) {
          vm.vectorId = viewResult.header.moduleId;
        }

        if (vm.module) {
          firebase.analytics().logEvent("screen_view", {
            screen_name: `${vm.header.documentId}|${vm.module.name}`,
          });
        } else {
          try {
            await clientStore.dispatch('loadWorkspaceModule', {
              moduleId: viewResult.header.moduleId,
            });
            if (!vm.module) throw "Error: module is not defined";
          } catch(loadWorkspaceModuleError) {
            console.error("QuickView:ViewForm", loadWorkspaceModuleError);
            vm.viewFormIsError = true;
            vm.viewFormError = moduleUnavailableMessage;
          }
        }
      } catch(err) {
        console.error("QuickView:ViewForm", err);
        this.viewFormIsError = true;
        this.viewFormError = entryUnavailableMessage;
        if (err.response && err.response.status === 400) {
          this.viewFormError = err.response.data && err.response.data.message || 'Something went wrong.';
        }
      }
    },
    async loadActivityForm() {
      try {
        let vm = this;
        vm.showEntryDetails = false;
        vm.activityFormIsError = false;
        let result = await classificationStore.dispatch("loadActivityForm", {
          query: vm.$route.query,
          locusId: vm.locusIds[0],
          vectorId: vm.vectorId,
          listingId: vm.listing,
          activityId: vm.selectedActivity.id,
          users: vm.users,
        });

        vm.header = result.header;
        vm.footer = result.footer;
        if (result.header && result.header.moduleId) {
          vm.vectorId = result.header.moduleId;
        }

        if (result.header && result.header.activity) {
          vm.selectedActivity = result.header.activity;
        }

        if (result.needSync && vm.selectedActivity) {
          vm.$refs.form.pollData(vm.selectedActivity);
        }

        if (vm.module) {
          firebase.analytics().logEvent("screen_view", {
            screen_name: `${vm.selectedActivity.name}|${vm.header.documentId}|${vm.module.name}`,
          });
        } else {
          console.error("QuickView:ActivityForm", "Error: module is not defined");
          vm.activityFormIsError = true;
          vm.activityFormError = moduleUnavailableMessage;
        }
      } catch(err) {
        console.error("QuickView:ActivityForm", err);
        this.activityFormIsError = true;
        this.activityFormError = activityUnavailableMessage;
        if (err.response && err.response.status === 400) {
          this.activityFormError = err.response.data && err.response.data.message || 'Something went wrong.';
        }
      }
    },
    async showDetails(val) {
      if (this.viewData == null) {
        await this.loadViewForm();
      }

      this.showEntryDetails = val;
    },
    addToForm(basketItems) {
      this.$refs.form.addToForm(basketItems);
    },
    moment,
    setRouter() {
      // route only set when modal is opened
      if (this.show && this.$route.name) {
        const routeQuery = this.fullView
          ? { ...this.$route.query, m: "f" }
          : { ...this.$route.query };
        // create activity
        if (this.selectedActivity && this.selectedActivity.id === "create") {
          this.$router.push({
            query: { ...routeQuery, a: this.selectedActivity.id },
          });
        } else if (this.formData && this.formData.id) {
          // execute activity
          if (this.selectedActivity) {
            this.$router.push({
              query: {
                ...routeQuery,
                id: commons.encodeids(this.formData.id),
                a: this.selectedActivity.id,
              },
            });
          }
          // view activity
          else {
            let query = {
              ...routeQuery,
              id: commons.encodeids(this.formData.id),
            };
            if (query.hasOwnProperty("a")) delete query.a;
            this.$router.push({ query: query });
          }
        }
      }
    },
    async openQuickView() {
      this.show = true;
    },
    closeQuickView() {
      if (this.$route.query.dialog)
        window.close();

      this.show = false;

      let query = {};
      if (this.$route.query.l) query.l = this.$route.query.l;
      if (this.$route.query.t) query.t = this.$route.query.t;
      this.$router.push({ query: query });

      if (this.refreshList)
        this.$emit("refresh", {
          moduleId: this.vectorId,
        });

      this.$emit("closed");
    },
    async toggleWatch() {
      await clientStore.dispatch("notificationWatch", {
        locusId: this.formData.id,
        watch: !this.header.watch,
        vectorId: this.vectorId,
      });
      this.header.watch = !this.header.watch;
    },
    toggleHistory() {
      this.$refs.ftsHistory.toggleHistory();
    },
    historyAdded() {
      this.refreshList = true;
      if (this.header.commentCount) this.header.commentCount += 1;
      else this.header.commentCount = 1;
    },
    async execute(x, type) {
      if (type == "activity" || type == "standard") {
        this.selectedActivity = x;
        this.setRouter();
        await this.loadActivityForm();
      } else if (type == "custom") {
        if (x.script) {
          let items = this.items;
          eval(x.script);
        }
      } else if (type == "document" || type == "template") {
        window.eventBus.$emit("showPDFDocument", {
          document: x,
          items: this.items,
          moduleId: this.vectorId,
        });
      } else {
        this.$emit("actionExecuted", { action: x, items: [this.formData] });
      }
    },
    async submit(formData) {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      let vm = this;
      this.submitting = true;
      
      try {
        let result = await classificationStore.dispatch("submitActivity", {
          activityId: this.selectedActivity.id,
          ids: this.items.map((x) => x.id),
          name: this.module.name,
          payload: formData,
          post: this.comment,
          intention: this.comment.attention,
          state: this.selectedState ? this.selectedState.name : null,
          assignees: this.formData.assignees,
          due: this.formData.due ? moment(this.formData.due).endOf('day') : null,
        });
        this.submitting = false;
        this.$toasted.success("Submission successful");
        this.refreshList = true;
        /* form ads */
        if (
          classificationStore.state.form &&
          classificationStore.state.form.ads
        ) {
          let entryId = result.data.id;
          try {
            eval(
              classificationStore.state.form &&
                classificationStore.state.form.ads
            );
          } catch (ex) {
            this.$toasted.error(ex);
          }
        }

        if (vm.$route.query.dialog) {
          /* dialog callback */
          window.opener.newAddedCallback({
            guid: vm.$route.query.dialog,
            id: result.data.entryId,
          });
          window.close();
        } else {
          this.closeQuickView();
        }
      } catch (err) {
        this.submitting = false;
        if (
          err &&
          err.response &&
          err.response.data &&
          err.response.data.message
        ) {
          this.$toasted.error(
            "Submission failed: " + err.response.data.message
          );
        } else {
          this.$toasted.error("Submission failed");
        }
      }
    },
    async cancel() {
      if (this.entry == "activity") {
        this.closeQuickView();
      } else {
        this.showEntryDetails = true;
        this.selectedActivity = null;
        this.setRouter();
        await this.loadViewForm(); 
      }
    },
    share() {
      try {
        // init
        const range = document.createRange();
        range.selectNode(document.body);
        // create node
        const newNode = document.createElement("a");
        newNode.setAttribute("href", window.location.href);
        // set innerText
        newNode.innerText = (this.header ? 
          `${this.header.documentId} ${this.header.title}` : ""
        ).trim();
        // insert and select node
        range.insertNode(newNode);
        range.selectNode(newNode);
        // selection
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
        // copy
        document.execCommand("copy");
        // remove node
        document.children[0].removeChild(newNode);

        this.$toasted.success("Copied.");
      } catch (err) {
        console.error(err);
        this.$toasted.global.error();
      }
    },
    async toggleView() {
      this.fullView = !this.fullView;
      /* route */
      if (this.$route.name) {
        if (this.fullView) {
          this.$router.replace({ query: { ...this.$route.query, m: "f" } });
        } else if (
          this.$route.query.m &&
          this.$route.query.m.toLowerCase() === "f"
        ) {
          let query = Object.assign({}, this.$route.query);
          delete query.m;
          this.$router.replace({ query: query });
        }
      }
      /* entry details */
      if (this.showEntryDetails)
        await this.loadViewForm();
    },
    executeAction(item) {
      this.execute(item, item.type);
    },
    // error
    validationError() {
      if (this.$v.selectedState && this.$v.selectedState.$error) {
        return "State is required."
      }
    },
  },
  computed: {
    isAdminUser() {
      return authorizationStore.getters.isAdminUser;
    },
    isFooter() {
      return (
        !this.fullView && 
        !this.isError &&
        (
          (
            this.entry === 'view' && 
            !this.selectedActivity &&
            this.footer && (
              !!(this.footer.activities && this.footer.activities.length) || 
              !!(this.footer.customs && this.footer.customs.length) || 
              !!(this.footer.documents && this.footer.documents.length)
            )
          ) ||
          (
            this.selectedActivity &&
            ["assign", "changeStatus", "delete", "duplicate"].indexOf(this.selectedActivity.id) > -1
          ) ||
          this.progress
        )
      )
    },
    fullViewRight() {
      return this.footer && this.footer.standards && this.footer.standards.indexOf('view') > -1;
    },
    commentRight() {
      return this.footer && this.footer.standards && this.footer.standards.indexOf('comment') > -1;
    },
    isError() {
      return (
        (!this.selectedActivity && this.viewFormIsError) ||
        (Boolean(this.selectedActivity) && this.activityFormIsError)
      );
    },
    isBackdrop() {
      return !this.submitting || this.entry == "view";
    },
    module() {
      return clientStore.state.workspace.vectors.find(
        (x) => x.id == this.vectorId
      );
    },
    states() {
      return clientStore.state.workspace.states.filter(
        (x) => x.module == this.vectorId.toString()
      );
    },
    users() {
      return clientStore.state.workspace.users;
    },
    formTitle() {
      if (this.items && this.items.length > 1)
        return `${this.items.length} items selected`;
      else if (this.header) return this.header.title;

      return "(untitled)";
    },
    multiple() {
      return this.items && this.items.length > 1;
    },
    locusIds() {
      return this.items ? this.items.map((x) => x.id) : [];
    },
    selectedItemsEtc() {
      if (!this.items || this.items < 2) return "";
      else if (this.items.length == 2) {
        return `${this.items[0].documentId} and ${this.items[1].documentId}`;
      } else if (this.items.length == 3) {
        return `${this.items[0].documentId}, ${this.items[1].documentId} and ${this.items[2].documentId}`;
      } else {
        return `${this.items[0].documentId}, ${this.items[1].documentId} and ${
          this.items.length - 2
        } others`;
      }
    },
    /* Activities only contain single activity */
    executableActivity() {
      if (this.footer.activities && this.footer.activities.length === 1)
        return this.footer.activities[0];
    },
    sidebarActions() {
      if (!this.footer) return [];

      let list = [];

      function addDivider() {
        if (list.length > 0)
          list.push({
            id: `action-divider-${list.length}`,
            optionRole: "divider",
          });
      }
      // Activities
      if (this.footer.activities && this.footer.activities.length) {
        this.footer.activities.forEach((x) => (x.type = "activity"));
        list = list.concat(this.footer.activities);
      }
      // Customs
      if (this.footer.customs && this.footer.customs.length) {
        addDivider();
        this.footer.customs.forEach((x) => (x.type = "custom"));
        list = list.concat(this.footer.customs);
      }

      // Documents
      if (this.footer.documents && this.footer.documents.length) {
        addDivider();
        this.footer.documents.forEach((x) => (x.type = "template"));
        list = list.concat(this.footer.documents);
      }

      // Standard Activities
      if (this.footer.standards && this.footer.standards.length) {
        addDivider();
        let standards = commons.standardActivities.filter(
          (x) =>
            this.footer.standards.indexOf(x.id) > -1 &&
            x.id != "view" &&
            x.id != "create"
        );
        standards.forEach((x) => (x.type = "standard"));
        list = list.concat(standards);
      }

      return list;
    },
    designRoute() {
      if (this.module && this.module.id) {
        if (this.selectedActivity && this.selectedActivity.id) {
          return {
            name: 'studio',
            query: {
              id: commons.encodeids(this.module.id),
              t: this.selectedActivity.standard ? 'standardActivity' : 'activity',
              tid: this.selectedActivity.id
            }
          }
        } else {
          return {
            name: 'studio',
            query: {
              id: commons.encodeids(this.module.id),
              t: 'standardActivity',
              tid: this.fullView ? 'view' : 'quickView'
            }
          }
        }
      }
    },
  },
  async mounted() {
    let vm = this;
    /* open quick view */
    window.eventBus.$on("quickViewData", async (res) => {
      if (res.fromUrl && vm.show) {
        var current = {
          id: vm.header ? vm.header.id : null,
          activityId: vm.selectedActivity ? vm.selectedActivity.id : null,
          vectorId: vm.vectorId,
          fullView: vm.fullView,
        };

        if (
          res.id == current.id &&
          res.activityId == current.activityId &&
          (!res.vectorId || res.vectorId == current.vectorId)
        ) {
          if (Boolean(current.fullView) != Boolean(res.fullView)) {
            await vm.toggleView();
          }
          return;
        }
      }

      vm.username = res.username;
      vm.fullView = res.fullView;
      vm.listing = res.listingId;

      if (
        res.activityId &&
        res.activityId != "view" &&
        res.activityId != "quickView"
      ) {
        vm.selectedActivity = res.activity;
        if (vm.selectedActivity == null) {
          vm.selectedActivity = commons.standardActivities.find(
            (x) => x.id == res.activityId
          );
        }

        if (vm.selectedActivity == null) {
          vm.selectedActivity = { id: res.activityId };
        }

        this.entry = "activity";
      } else {
        vm.selectedActivity = null;
        this.entry = "view";
      }

      try {
        this.vectorId = res.vectorId;
        if (Array.isArray(res.items) && res.items.length) {
          this.items = res.items;
          this.header = res.items[0];
          this.formData = res.items[0];
        } else if (res.id) {
          this.items = [{id: res.id}];
          this.header = {id: res.id}; 
          this.formData = {id: res.id};
        } else {
          this.items = [];
        }

        await classificationStore.dispatch("resetActivityForm");
        this.loading = true;
        this.openQuickView();
        
        if (!this.selectedActivity) {
          await vm.loadViewForm();
        } else {
          await vm.loadActivityForm();
          if (
            res.activityId == "create" &&
            vm.username &&
            classificationStore.state.formData
          ) {
            classificationStore.state.formData["username"] = vm.username;
          }
        }

        this.loading = false;
        if (this.$route.name) this.setRouter();
      } catch (err) {
        console.error(err);
      }
    });
    /* close quick view */
    window.eventBus.$on("closeQuickView", () => {
      if (this.show) {
        this.closeQuickView();
      }
    });
    /* activity process */
    window.eventBus.$on("activityProcess", (data) => {
      if (
        vm.formData &&
        vm.formData.id &&
        data.EntryId == vm.formData.id.toString()
      ) {
        vm.progress = `${data.Progress}/${data.Total}`;

        if (data.Progress == data.Total) {
          vm.progress = "";
        }
      }
    });
  },
  beforeDestroy() {
    window.eventBus.$off("quickViewData");
    window.eventBus.$off("closeQuickView");
    window.eventBus.$off("activityProcess");
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";
@import "/scss/style.scss";

.fts-quick-view {
  &:not(.full-modal) {
    > .fts-modal-wrapper {
      max-width: 1280px;
    }
  }
  >.fts-modal-wrapper {
    > .quick-view-modal-container {
      overflow: auto;
    }
  }
  .quick-view__header,
  .quick-view__content,
  .quick-view__footer {
    min-width: 900px;
  }
  .quick-view__content {
    display: flex;
  }
  .quick-view__footer {
    border-top: 1px solid var(--fts-gray-2);
    .footer-action {
      padding: .75rem;
    }
    .footer-standard {
      padding: 1rem;
      text-align: right;
    }
  }
  // classification
  .content-body-classification {
    > .fts-form-container {
      padding-top: 1rem;
    }
  }

  .full-view-standard {
    margin: 2rem 0.375rem 1rem;
    text-align: right;
  }

  // quick view fab
  .quick-view-fab {
    position: relative;
    .quick-view-fab-wrapper {
      position: absolute;
      left: 0;
      bottom: 1rem;
      transform: translateX(calc(-100% - 1rem));
    }
    .quick-view-fab--single {
      @include text-overflow-ellipsis;
      max-width: 250px;
      white-space: nowrap;
    }
  }
  // history count
  .history-count-wrapper {
    position: relative;
    padding-right: 0.575rem;
    .history-count {
      @include absolute-center-y;
      left: 26px;
      min-width: 1rem;
      padding: 0 2px;
      border: 1px solid transparent;
      border-radius: 10em;
      font-size: 0.675rem;
      color: var(--fts-gray-5);
      text-align: center;
      transition: all 0.3s ease-in-out;
    }
    .fts-btn:hover + .history-count {
      background: $primaryColor;
      color: #fff;
    }
  }
  // error
  .error-wrapper {
    padding: 2rem;
    text-align: center;
    .error-icon {
      height: 80px;
      width: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto 1.5rem;
      border: 2px solid var(--fts-danger);
      border-radius: 50%;
      color: var(--fts-danger);
      > svg {
        color: inherit;
        font-size: 2.5rem;
      }
    }
    .error-title {
      margin-bottom: .575rem;
      font-size: 1.25rem;
      font-weight: 600;
      color: var(--fts-danger);
      line-height: 1.5;
      word-break: break-word;
    }
    .error-description {
      color: var(--fts-gray-5);
      font-size: .875rem;
      line-height: 1.5;
      word-break: break-word;
    }
  }
}

// Standard Activity
.standard-activity-form {
  margin-bottom: 1rem;
  .standard-activity-form-content {
    &.single-selected {
      padding-bottom: 1.975rem; // original 1.5rem + .375rem (view details margin-bottom)
    }
    padding: 1.5rem 0.875rem;
  }
  .standard-activity-form-title {
    font-size: 1rem;
    text-align: center;
  }
  .standard-activity-state {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    .state-label {
      margin-right: 0.375rem;
      white-space: nowrap;
    }
    .state-dropdown {
      min-width: 0;
    }
    .state-error {
      margin-top: .375rem;
      font-size: .75rem;
      color: var(--fts-danger);
    }
  }
  .standard-activity-comment {
    margin: 0 0.375rem;
  }
}

.standard-activity-icon {
  margin-right: 0.375rem;
  &.standard-activity-icon-lg {
    font-size: 1.25rem;
  }
}

// transition
.fade-in-enter-active {
  transition: opacity .6s ease-in;
}
.fade-in-enter, .fade-in-leave-to {
  opacity: 0;
}
</style>